// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Og-hBU"};